import { render, staticRenderFns } from "./ot-edit-organisation-details.vue?vue&type=template&id=2a798b5a&scoped=true&"
import script from "./ot-edit-organisation-details.vue?vue&type=script&lang=ts&"
export * from "./ot-edit-organisation-details.vue?vue&type=script&lang=ts&"
import style0 from "./ot-edit-organisation-details.vue?vue&type=style&index=0&id=2a798b5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a798b5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VDivider,VForm,VOverlay})
